const BNPL_LABELS = {
  KLARNA: 'Klarna',
  AFFIRM: 'Affirm'
};
const CUSTOM_LABELS = {
  PADS: 'PADs'
};

// Commerce-wide payment method display format. Change this with caution. This util is used in multiple app and libs.
export function formattedPaymentMethodLabel(paymentMethodType, brand, last4) {
  var _CUSTOM_LABELS$capita;
  const capitalizedPaymentMethodType = paymentMethodType.toUpperCase();
  if (paymentMethodType in BNPL_LABELS) {
    var _BNPL_LABELS$paymentM;
    return (_BNPL_LABELS$paymentM = BNPL_LABELS[paymentMethodType]) !== null && _BNPL_LABELS$paymentM !== void 0 ? _BNPL_LABELS$paymentM : paymentMethodType;
  }
  const label = capitalizedPaymentMethodType === 'CARD' && brand ? brand.toUpperCase() : (_CUSTOM_LABELS$capita = CUSTOM_LABELS[capitalizedPaymentMethodType]) !== null && _CUSTOM_LABELS$capita !== void 0 ? _CUSTOM_LABELS$capita : capitalizedPaymentMethodType;
  return last4 ? `${label} ****${last4}` : label;
}